import * as LDClient from "launchdarkly-js-client-sdk";
import { useEffect } from "react";
import { useAppSelector } from "src/store/hooks";

export class LaunchDarklyService {
  private static instance: LaunchDarklyService;
  private static client: LDClient.LDClient | null = null;

  private constructor() {}

  static getInstance(): LaunchDarklyService {
    if (!LaunchDarklyService.instance) {
      LaunchDarklyService.instance = new LaunchDarklyService();
    }
    return LaunchDarklyService.instance;
  }

  async init(user: LDClient.LDSingleKindContext) {
    if (LaunchDarklyService.client) return LaunchDarklyService.client;

    LaunchDarklyService.client = LDClient.initialize(import.meta.env.VITE_LD_CLIENT_ID, user, {
      bootstrap: "localStorage",
      streaming: true,
    });

    await LaunchDarklyService.client.waitForInitialization(5);

    return LaunchDarklyService.client;
  }

  static async isFlagEnabled(flagKey: string, defaultValue = false): Promise<boolean> {
    try {
      if (!LaunchDarklyService.client) {
        throw new Error("LaunchDarkly not initialized");
      }

      const ld = LaunchDarklyService.client;
      return ld.variation(`sfweb_${flagKey}`, defaultValue);
    } catch {
      return defaultValue;
    }
  }
}

export function LaunchDarklyBootstrap() {
  const email = useAppSelector((state) => state.auth.userInfo?.email);

  useEffect(() => {
    if (!email) return;

    async function bootstrap() {
      const ldService = LaunchDarklyService.getInstance();
      await ldService.init({
        kind: "user",
        key: email,
      });
    }

    bootstrap();
  }, [email]);

  return null;
}
